module.exports = __webpack_public_path__ + "static/media/map-mark-login.2f223e81.png";